export enum CurrenciesActionType {
  LoadCurrencies = 'currencies/load',
}
